export  const gameDataBeta = [
    {
        "id": 0,
        "program": "Level Up 2022",
        "games": [
            {
                "name": "This is a game", 
                "description": "This is not a game to be played lightly"

            }, {
                "name": "This is also a game",
                "description": "This will be a game to be played lightly"
            }
        ]
    }, {
        "id": 1, 
        "program": "Level Up 2023", 
        "games": [
            {
                "name": "Astro-Tracker", 
                "description": "This is not a game to be played lightly"

            }, {
                "name": "Nevermind The Game",
                "description": "This will be a game to be played lightly"
            }
        ]
    }, {
        "id": 2, 
        "program": "Digital Design & Production", 
        "games": [
            {
                "name": "Astro-Tracker", 
                "description": "This is not a game to be played lightly"

            }, {
                "name": "Nevermind The Game",
                "description": "This will be a game to be played lightly"
            }
        ]
    }, {
        "id": 2, 
        "program": "Digital Design & Production", 
        "games": [
            {
                "name": "Astro-Tracker", 
                "description": "This is not a game to be played lightly"

            }, {
                "name": "Nevermind The Game",
                "description": "This will be a game to be played lightly"
            }
        ]
    }, {
        "id": 2, 
        "program": "Digital Design & Production", 
        "games": [
            {
                "name": "Astro-Tracker", 
                "description": "This is not a game to be played lightly"

            }, {
                "name": "Nevermind The Game",
                "description": "This will be a game to be played lightly"
            }
        ]
    }
]